import React, { useState } from "react";
import { FaList, FaCheck, FaSave, FaEdit, FaTrash } from "react-icons/fa";
import "./App.css";

const App = () => {
  const [task, setTask] = useState("");
  const [tasks, setTasks] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [editText, setEditText] = useState("");
  const [error, setError] = useState(false);

  // Add Task
  const handleAddTask = () => {
    if (task.trim() === "") {
      setError(true);
      return;
    }
    setTasks([...tasks, { text: task, completed: false }]); // object save
    setTask("");
    setError(false);
  };

  // Edit Task
  const handleEditTask = (index) => {
    setEditIndex(index);
    setEditText(tasks[index].text);
  };

  // Save Task
  const handleSaveTask = () => {
    const updatedTasks = [...tasks];
    updatedTasks[editIndex].text = editText;
    setTasks(updatedTasks);
    setEditIndex(null);
    setEditText("");
  };

  // Delete Task
  const handleDeleteTask = (index) => {
    setTasks(tasks.filter((_, i) => i !== index));
  };

  // Toggle Complete (line-through)
  const handleToggleComplete = (index) => {
    const updatedTasks = [...tasks];
    updatedTasks[index].completed = !updatedTasks[index].completed;
    setTasks(updatedTasks);
  };

  return (
    <div className="container">
      <div className="to-do-list-box">

        {/* Heading */}
        <div className="heading">
          <h2 className="heading-title">To-Do List</h2>
          <FaList className="heading-icon" />
        </div>

        {/* Input Section */}
        <div className="input-box">
          <input type="text" placeholder="Add a new task..." value={task} onChange={(e) => { setTask(e.target.value); setError(false); }} className={`task-input ${error ? "error-input" : ""}`} />
          <button className="add-btn" onClick={handleAddTask}> <FaCheck /> ADD </button>
        </div>

        {/* Error Message */}
        {error && <p className="error-text">⚠ Please enter a task</p>}

        {/* Task List */}
        <div className="task-list">
          <ul>
            {tasks.map((t, index) => (
              <li key={index} className="task-item">
                {editIndex === index ? (
                  <>
                    <input type="text" value={editText} onChange={(e) => setEditText(e.target.value)} className="edit-input" />
                    <button className="save-btn" onClick={handleSaveTask}> <FaSave /> SAVE  </button>
                  </>
                ) : (
                  <>
                    {/* Line Number + Task */}
                    <span className={`task-text ${t.completed ? "completed" : ""}`} onClick={() => handleToggleComplete(index)} > {index + 1}. {t.text} </span>

                    {/* Actions */}
                    <div className="task-actions">
                        <button className="edit-btn" onClick={() => handleEditTask(index)} > <FaEdit /> </button>
                        <button className="delete-btn" onClick={() => handleDeleteTask(index)} > <FaTrash /> </button>
                    </div>
                  </>
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default App;